import Request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 接口信息
   */
  static getWalletInfo(params) {
    const { lyUrl } = params || {};
    return Request({
      url: lyUrl
        ? lyUrl
        : params
          ? `wallet/queryAccounts?accountType=${params.accountType}`
          : `wallet/queryAccounts`,
      host: config.HOST_MALL
    });
  }

  /**
   * 获取最新一项明细
   */
  static getLatestTransaction() {
    return Request({
      url: `wallet/queryAccountTradeInfos/0/1/1`,
      host: config.HOST_MALL
    });
  }

  /**
   * 获取各种优惠券数量
   */
  static getCouponCount(params) {
    return Request({
      url: `coupon/count`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  // 获取预计收益
  static getRecommendedAward(cardCode) {
    return Request({
      url: `personal/queryRecommendedAward?cardCode=${cardCode}`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Wallet/BonusWallet/BonusWalletServ.js